import { darkTheme } from '../../lib/tokens';
import { KNOWN_APPS, ALL_APPS } from '../../lib/appConstants';
import { useAppContextStore } from './appContextStore';

const OPTIONS = [{ id: ALL_APPS, label: 'Alle Apps' }, ...KNOWN_APPS];

// Globaler App-Picker in der TopBar: wählt die aktuell verwaltete Lern-App.
// Setzt den globalen App-Kontext (appContextStore) — app-gebundene Aktionen wie
// der Broadcast-Versand ziehen daraus ihre Default-Ziel-App.
export function AppPicker(): JSX.Element {
  const appId = useAppContextStore((s) => s.appId);
  const setAppId = useAppContextStore((s) => s.setAppId);

  return (
    <div className="flex items-center gap-1" role="group" aria-label="App-Kontext">
      {OPTIONS.map((a) => {
        const active = a.id === appId;
        return (
          <button
            key={a.id}
            type="button"
            onClick={() => setAppId(a.id)}
            aria-pressed={active}
            className="rounded-md px-2.5 py-1 text-xs transition-colors"
            style={{
              background: active ? darkTheme.colors.accentSubtle : darkTheme.colors.bgSurface,
              color: active ? darkTheme.colors.accentLight : darkTheme.colors.textSecondary,
              border: `1px solid ${active ? darkTheme.colors.accent : darkTheme.colors.borderSubtle}`,
            }}
          >
            {a.label}
          </button>
        );
      })}
    </div>
  );
}
